import { render } from "./Properties.vue?vue&type=template&id=671b8e7c&scoped=true&ts=true"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"

import "./Properties.vue?vue&type=style&index=0&id=671b8e7c&scoped=true&lang=css"

import exportComponent from "/Volumes/jstChillin/Dropbox/pdc2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671b8e7c"]])

export default __exports__